import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    shoppableImage: {
        position: 'relative',
        width: '100%',
        paddingTop: '100%',
        [theme.breakpoints.up('sm')]: {
            width: '50%',
            paddingTop: '50%',
        },
        '& img': {
            width: '100%',
            height: '100%',
        },
    },
    desktopImage: {
        display: 'none',
        '& > .displayDesktopImage': {
            display: 'block',
        },
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    mobileImage: {
        display: 'block',
        '& button': {
            paddingTop: '100%',
        },
        [theme.breakpoints.up('sm')]: {
            display: 'none',
            paddingTop: 0,
        },
    },
    displayDesktopImage: {
        display: 'block',
    },
}));
export default useStyles;
